/*
 * PDP V2 buy box behaviour: coupon copy buttons and the live-viewer counter.
 * Loaded only when a product section uses the V2 buy box design.
 */
(function () {
  'use strict';

  function flashLabel(button, message) {
    var label = button.querySelector('[data-pdp-copy-label]');
    if (!label) return;
    if (button.dataset.pdpCopyBusy === '1') return;

    var original = label.textContent;
    button.dataset.pdpCopyBusy = '1';
    button.classList.add('is-copied');
    label.textContent = message;

    setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-copied');
      delete button.dataset.pdpCopyBusy;
    }, 1800);
  }

  function legacyCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (e) {
      copied = false;
    }

    document.body.removeChild(field);
    return copied;
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-pdp-copy]').forEach(function (button) {
      if (button.dataset.pdpCopyBound === '1') return;
      button.dataset.pdpCopyBound = '1';

      button.addEventListener('click', function () {
        var code = button.getAttribute('data-pdp-copy') || '';
        if (!code) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              flashLabel(button, 'Copied');
            },
            function () {
              flashLabel(button, legacyCopy(code) ? 'Copied' : code);
            }
          );
        } else {
          flashLabel(button, legacyCopy(code) ? 'Copied' : code);
        }
      });
    });
  }

  /* Drifts within the merchant-configured range so the number feels live.
     This is a display device, not a real concurrent-visitor count. */
  function initViewerCounters(root) {
    root.querySelectorAll('[data-pdp-viewers]').forEach(function (element) {
      if (element.dataset.pdpViewersBound === '1') return;
      element.dataset.pdpViewersBound = '1';

      var output = element.querySelector('[data-pdp-viewers-count]');
      if (!output) return;

      var min = parseInt(element.getAttribute('data-min'), 10);
      var max = parseInt(element.getAttribute('data-max'), 10);
      var seconds = parseInt(element.getAttribute('data-interval'), 10);

      if (isNaN(min)) min = 12;
      if (isNaN(max)) max = 60;
      if (max < min) max = min;
      if (isNaN(seconds) || seconds < 3) seconds = 8;

      function pick(previous) {
        var span = max - min;
        if (span <= 0) return min;

        /* Small step from the previous value reads as real traffic;
           a fresh random number every tick does not. */
        if (typeof previous === 'number') {
          var step = Math.max(1, Math.round(span * 0.12));
          var drift = Math.floor(Math.random() * (step * 2 + 1)) - step;
          var next = previous + drift;
          if (next < min) next = min + Math.abs(drift);
          if (next > max) next = max - Math.abs(drift);
          return Math.min(max, Math.max(min, next));
        }

        return min + Math.floor(Math.random() * (span + 1));
      }

      var current = pick();
      output.textContent = current;

      setInterval(function () {
        current = pick(current);
        output.textContent = current;
      }, seconds * 1000);
    });
  }

  function navigableMediaIds(gallery) {
    var ids = [];
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item[data-target]');

    thumbs.forEach(function (thumb) {
      if (thumb.classList.contains('thumbnail-list_item--variant')) return;
      var id = thumb.getAttribute('data-target');
      if (id) ids.push(id);
    });

    if (!ids.length) {
      gallery.querySelectorAll('.product__media-item[data-media-id]').forEach(function (item) {
        if (item.classList.contains('product__media-item--variant')) return;
        var id = item.getAttribute('data-media-id');
        if (id) ids.push(id);
      });
    }

    return ids;
  }

  function showMedia(gallery, mediaId) {
    if (!mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
      return;
    }

    var thumbButton = gallery.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"] button');
    if (thumbButton) thumbButton.click();
  }

  function stepMedia(gallery, direction) {
    var ids = navigableMediaIds(gallery);
    if (ids.length < 2) return;

    var active = gallery.querySelector('.product__media-item.is-active');
    var currentId = active ? active.getAttribute('data-media-id') : ids[0];
    var index = ids.indexOf(currentId);
    if (index < 0) index = 0;

    var nextIndex = (index + direction + ids.length) % ids.length;
    showMedia(gallery, ids[nextIndex]);
  }

  function initMediaArrows(root) {
    root.querySelectorAll('.pdp-v2 bs-media-gallery, bs-media-gallery').forEach(function (gallery) {
      if (!gallery.closest('.pdp-v2')) return;
      if (gallery.dataset.pdpMediaNavBound === '1') return;
      gallery.dataset.pdpMediaNavBound = '1';

      var prev = gallery.querySelector('[data-pdp-media-prev]');
      var next = gallery.querySelector('[data-pdp-media-next]');
      if (!prev || !next) return;

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepMedia(gallery, -1);
      });
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepMedia(gallery, 1);
      });
    });
  }

  function init(root) {
    var scope = root || document;
    initCopyButtons(scope);
    initViewerCounters(scope);
    initMediaArrows(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Re-bind when the theme editor re-renders the product section */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
